export default {
    resolveSource(response) {
        const data = response.data;

        if (data.delivery === 'url' && data.url) {
            return data.url;
        }

        if (data.file) {
            return data.file;
        }

        throw new Error('Resposta de arquivo inválida.');
    },

    async openWindow(response) {
        const source = this.resolveSource(response);

        if (source.startsWith('http://') || source.startsWith('https://')) {
            window.open(source, 'visualizarArquivos', 'width=800,height=800');
            return;
        }

        const base64Response = await fetch(source);
        const blob = await base64Response.blob();
        const blobUrl = URL.createObjectURL(blob);

        window.open(blobUrl, 'visualizarArquivos', 'width=800,height=800');

        URL.revokeObjectURL(blobUrl);
    },

    async download(response) {
        const source = this.resolveSource(response);

        if (source.startsWith('http://') || source.startsWith('https://')) {
            const anchor = document.createElement('a');
            anchor.href = source;
            anchor.download = response.data.name;
            anchor.rel = 'noopener';
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            return;
        }

        const base64Response = await fetch(source);
        const blob = await base64Response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const anchor = document.createElement('a');
        anchor.href = blobUrl;
        anchor.download = response.data.name;
        document.body.appendChild(anchor);
        anchor.click();

        document.body.removeChild(anchor);
        URL.revokeObjectURL(blobUrl);
    },

    async downloadBlob(response) {
        const href  = URL.createObjectURL(response.data);
        const a     = document.createElement('a');

        a.href      = href;
        a.download  = response.headers.filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(href);
    },
}
